import AbstractConfig from "../../../core/config/AbstractConfig";
import DashboardTrendDefinition from "./DashboardTrendDefinition";
import DashboardRCCEDefinition from "./DashboardRCCEDefinition";

export default class DashboardConfig extends AbstractConfig {
    constructor() {
        super();

        this._savedDashboardConfig = null;

    }

    /**
     * @returns {Array<DashboardTrendDefinition>}
     */
    getDashboardTrendDefinition(dashboardName) {

        const dashboardObj = this.getGerericDashboard(dashboardName);

        const dashboardDefinitions = [];
        for (const [key, value] of Object.entries(dashboardObj)) {
            const dashboardDefinition = new DashboardTrendDefinition(
                key,
                value?.column,
                value?.localizedLabel,
                value?.greenTrendOnPositiveData,
            );
            dashboardDefinitions.push(dashboardDefinition);
        }

        return dashboardDefinitions;
    }

    /**
     * @returns {Array<DashboardRCCEDefinition>}
     */
    getDashboardRCCEDefinition() {
        
        const dashboardObj = this.getGerericDashboard("RCCE");

        const dashboardDefinitions = [];
        for (const [key, value] of Object.entries(dashboardObj)) {
            const dashboardDefinition = new DashboardRCCEDefinition(
                key,
                value?.week,
            );
            dashboardDefinitions.push(dashboardDefinition);
        }

        return dashboardDefinitions;
    }

    getRCCEMovieClipPerWeek(week) {
        const config = this.getSaveConfig()
        console.log(config);

        return config.RCCE.movieClipPerWeek[week];
    }

    getSaveConfig() {
        if(this._savedDashboardConfig == null) {
            this._savedDashboardConfig = this.getValue('dashboard');
            return this._savedDashboardConfig;
        } else {
            return this._savedDashboardConfig;
        }
    }

    getGerericDashboard(dashboardName) {
        const dashboard = this.getSaveConfig();

        return dashboard[dashboardName];
    }

    get dashboardEpi() {
        this.getDashboardTrendDefinition("epi");
    }

    get dashboardHealthSystems() {
        this.getDashboardTrendDefinition("healthSystems");
    }

    get dashboardRCCE() {
        this.getDashboardRCCEDefinition();
    }
}
